;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();import React from 'react';

import cx from 'classnames';
import PropTypes from 'prop-types';

import ButtonCircle from 'components/ui/ButtonCircle';
import Img from 'components/ui/Img';
import EntryLink from 'components/ui/Link/EntryLink';
import Text from 'components/ui/Text';

import { getColor } from 'utils';
import { addProtocol } from 'utils/url';

import styles from './CardInternalLink.module.scss';

const CardInternalLink = ({
    className,
    imageDesktop,
    imageMobile,
    text,
    textColor,
    link,
}) => {
    const fallbackSrc = imageMobile?.url || imageDesktop?.url;
    const desktopSrc = imageDesktop?.url || imageMobile?.url;

    const customSources = desktopSrc
        ? [
              {
                  breakpoint: 768,
                  imageWidth: 768,
                  src: addProtocol(desktopSrc),
              },
          ]
        : [];

    const cardStyles = {
        ...(textColor && {
            '--card-text-color': getColor(textColor),
        }),
    };

    return (
        <EntryLink entry={link} className={cx(styles.cardLinkWrap, className)}>
            <article className={styles.card} style={cardStyles}>
                {fallbackSrc && (
                    <Img
                        className={styles.image}
                        src={addProtocol(fallbackSrc)}
                        fallbackImageWidth={768}
                        customSources={customSources}
                    />
                )}
                {text && (
                    <Text
                        as="p"
                        baseTheme="headingSmall"
                        themes={{ medium: 'headingLarge' }}
                        className={styles.text}
                        fixWidows
                    >
                        {text}
                    </Text>
                )}
                <ButtonCircle
                    as="span"
                    theme="small-fill-white"
                    iconType="arrowRight"
                    className={styles.linkBtn}
                    iconClassName={styles.linkBtnIcon}
                    aria-hidden="true"
                />
            </article>
        </EntryLink>
    );
};

CardInternalLink.propTypes = {
    className: PropTypes.string,
    imageDesktop: PropTypes.object,
    imageMobile: PropTypes.object,
    text: PropTypes.string,
    textColor: PropTypes.string,
    link: PropTypes.object,
};

export default CardInternalLink;
